import { useState, useRef } from "react";
import PropTypes from "prop-types";
import { BadgeCheck, CircleX } from "lucide-react";

import './Input.scss';

export default function CreditCardInput({ setCardNumber = () => {} }) {
  const [inputs, setInputs] = useState(['', '', '', '']);
  const inputRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];

  const handleInput = (index, value, event) => {
    const newInputs = [...inputs];
    const sanitizedValue = value.replace(/[^0-9.]/g, '');

    if (event.key === 'Backspace') {
      if (value === '' && index > 0) {
        inputRefs[index - 1].current.focus();
      }
    } else {
      newInputs[index] = sanitizedValue.slice(0, 4);
      setInputs(newInputs);

      if (sanitizedValue.length === 4 && index < 1) {
        inputRefs[index + 1].current.focus();
      }
    }

    if (index === 1) {
      newInputs[2] = sanitizedValue.length === 4 ? 'XXXX' : '';
      newInputs[3] = sanitizedValue.length === 4 ? 'XXXX' : '';
    }
    setCardNumber(newInputs.slice(0, 2).join(''));
  };

  const renderInput = (id, index, disabled = false) => (
    <input
      className="cardInput"
      id={`input${id}`}
      value={inputs[index]}
      inputMode="numeric"
      onChange={(e) => handleInput(index, e.target.value.replace(/[^0-9]/g, ''), e)}
      onKeyDown={(e) => handleInput(index, e.target.value, e)}
      maxLength={4}
      disabled={disabled}
      ref={inputRefs[index]}
    />
  );

  return (
    <div className="creditCardInput">
      {renderInput(1, 0)}
      {renderInput(2, 1)}
      {renderInput(3, 2, true)}
      {renderInput(4, 3, true)}
    </div>
  );
};

export const SuccessMessage = ({ message = '' }) => {
  return (
    <>
      {message && (
        <div className="successLoginMessage">
          <BadgeCheck color="#09CB11" size={18} />
          {message}
        </div>
      )}
    </>
  );
};

export const ErrorMessage = ({ error = '', message = '' }) => {
  return (
    <>
      {error && !message && (
        <div className="errorLoginMessage">
          <CircleX color="#e52424" size={18} />
          {error}
        </div>
      )}
    </>
  );
};

CreditCardInput.propTypes = {
  setCardNumber: PropTypes.func.isRequired,
};